import { Box, HStack, Body, Icon, Container } from '@hover/blueprint';
import React, { useEffect, useState } from 'react';
import { HOME_PAGE_TABS } from '../../../constants';
import { Progress } from '../../ui';
import { IHomePageTabs } from '../../../interfaces/IHomePageTabs';

const TABS_NAME = HOME_PAGE_TABS.map(listItem => listItem.title);

interface Props {
  currentTab: string;
  resetTimer: (title: string) => void;
}

const BetterSectionMobileTabs: React.FC<Props> = ({
  currentTab,
  resetTimer,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const index = HOME_PAGE_TABS.findIndex(tab => tab.title === currentTab);

  useEffect(() => {
    setIsLoading(false);
  }, []);

  useEffect(() => {
    const scrollingSection = document.getElementById(
      'better-section-horizontal-scroll',
    );

    if (scrollingSection) {
      if (currentTab === TABS_NAME[TABS_NAME.length - 1]) {
        scrollingSection.scrollTo({ left: scrollingSection.scrollWidth });
      } else if (currentTab === TABS_NAME[0]) {
        scrollingSection.scrollTo({ left: 0 });
      }
    }
  }, [currentTab]);

  const onChange = (title: string, id: number) => {
    resetTimer(title);
    const scrollingSection = document.getElementById(
      'better-section-horizontal-scroll',
    );

    if (scrollingSection) {
      if (title === TABS_NAME[TABS_NAME.length - 1]) {
        scrollingSection.scrollTo({ left: scrollingSection.scrollWidth });
      } else if (title === TABS_NAME[0]) {
        scrollingSection.scrollTo({ left: 0 });
      }
    }

    const element = document.getElementById(
      `home-page-tabs-mobile-${id}`,
    ) as HTMLVideoElement;
    const prevElement = document.getElementById(
      `home-page-tabs-mobile-${index ?? 0}`,
    ) as HTMLVideoElement;
    if (prevElement) {
      prevElement.pause();
      prevElement.currentTime = 0;
    }
    if (element) {
      element.currentTime = 0;
      void element.play();
    }
    resetTimer(title);
  };

  useEffect(() => {
    if (!isLoading) {
      const element = document.getElementById(
        `home-page-tabs-mobile-${index ?? 0}`,
      ) as HTMLVideoElement;
      if (element) {
        void element.play();
      }
    }
  }, [isLoading, currentTab]);

  return (
    <Box
      d={{ base: 'flex', tablet: 'none' }}
      w="100%"
      maxW="100%"
      overflow="hidden"
      flexDir="column"
      mt={900}
    >
      <HStack
        id="better-section-horizontal-scroll"
        px={500}
        alignItems="center"
        w="100%"
        overflow="scroll"
        mb={500}
        css={{
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}
      >
        {HOME_PAGE_TABS.map((listItem: IHomePageTabs) => {
          const isCurrent = listItem.title === currentTab;
          return (
            <Box
              w="100%"
              onClick={() => onChange(listItem.title, listItem.id)}
              key={listItem.title}
              flexDir="column"
              alignItems="center"
              justifyContent="center"
              minW="100px"
              h="100%"
              minH="88px"
              maxH="88px"
            >
              {listItem.icon ? (
                <Icon
                  mb={200}
                  icon={listItem.icon}
                  size="default"
                  color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
                />
              ) : (
                <Icon
                  mb={200}
                  icon={!isCurrent ? listItem.svgIcon : listItem.svgIconActive}
                  size="default"
                  color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
                />
              )}
              <Body
                color={isCurrent ? 'brandNavy.500' : 'neutral.500'}
                textAlign="center"
                isBold
                size={200}
                mb={400}
                textTransform="uppercase"
              >
                {listItem.title.toUpperCase()}
              </Body>
              {isCurrent && !isLoading ? (
                <Progress />
              ) : (
                <Box h="2px" w="100%" />
              )}
            </Box>
          );
        })}
      </HStack>
      {HOME_PAGE_TABS.map(listItem => {
        const isCurrent = listItem.title === currentTab;
        return (
          <Container
            key={listItem.title}
            d={isCurrent ? 'flex' : 'none'}
            alignItems="center"
            justifyContent="center"
            flexDir="column"
          >
            <Box maxH="355px" position="relative">
              {listItem.renderVideo({
                loop: true,
                id: `home-page-tabs-mobile-${listItem.id}`,
                className: 'hero-page-tab-mobile',
              })}
              <Box
                position="absolute"
                bottom="-5px"
                h="10px"
                left={0}
                right={0}
                bg="neutral.0"
              />
            </Box>
            <Body
              mt={500}
              size={600}
              color={isCurrent ? 'neutral.700' : 'neutral.500'}
            >
              {listItem.body}
            </Body>
          </Container>
        );
      })}
    </Box>
  );
};

export default BetterSectionMobileTabs;
